
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/rethinking-democracy-in-africa",
      function () {
        return require("private-next-pages/articles/rethinking-democracy-in-africa.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/rethinking-democracy-in-africa"])
      });
    }
  